import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { OnboardingConsentPageViewedEventTracking } from '@/modules/auth/models/segmentevents/OnboardingConsentPageViewedEventTracking';

export class OnboardingConsentPageCompletedEventTracking extends OnboardingConsentPageViewedEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ONBOARDING_CONSENT_PAGE_COMPLETED;
  consent_advisor_access?: boolean;

  constructor(eventProperties: Partial<OnboardingConsentPageCompletedEventTracking> = {}) {
    super(eventProperties);
    this.consent_advisor_access = eventProperties?.consent_advisor_access;
  }
}
